import { render, staticRenderFns } from "./RouterStates.vue?vue&type=template&id=5493f83a&scoped=true&"
import script from "./RouterStates.vue?vue&type=script&lang=js&"
export * from "./RouterStates.vue?vue&type=script&lang=js&"
import style0 from "./RouterStates.vue?vue&type=style&index=0&id=5493f83a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5493f83a",
  null
  
)

export default component.exports